import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { compose } from 'redux';

import { CompanyContext } from 'common/containers/CompanyContainer';
import { GetExperimentGroupsContext } from 'common/containers/ExperimentContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import Helmet from 'common/helmets/Helmet';
import withContexts from 'common/util/withContexts';

import cloneElementWithProps from '../core/cloneElementWithProps';

export const TrackSegmentEventContext = React.createContext();

const SegmentKey = 'gHvwYijbq3zOBgOAPR8T0E3NNwi4nbc2';

let sdkLoaded = false;
function loadSegmentSDK() {
  if (sdkLoaded) {
    return;
  }

  /* eslint-disable */
  !(function () {
    var analytics = (window.analytics = window.analytics || []);
    if (!analytics.initialize)
      if (analytics.invoked)
        window.console && console.error && console.error('Segment snippet included twice.');
      else {
        analytics.invoked = !0;
        analytics.methods = [
          'trackSubmit',
          'trackClick',
          'trackLink',
          'trackForm',
          'pageview',
          'identify',
          'reset',
          'group',
          'track',
          'ready',
          'alias',
          'debug',
          'page',
          'once',
          'off',
          'on',
          'addSourceMiddleware',
          'addIntegrationMiddleware',
          'setAnonymousId',
          'addDestinationMiddleware',
        ];
        analytics.factory = function (e) {
          return function () {
            var t = Array.prototype.slice.call(arguments);
            t.unshift(e);
            analytics.push(t);
            return analytics;
          };
        };
        for (var e = 0; e < analytics.methods.length; e++) {
          var key = analytics.methods[e];
          analytics[key] = analytics.factory(key);
        }
        loadScript(
          `https://sgmnt-cdn.canny.io/analytics.js/v1/${SegmentKey}/analytics.min.js`,
          'segment-script'
        );
        analytics.SNIPPET_VERSION = '4.13.1';
      }
  })();
  /* eslint-enable */

  sdkLoaded = true;
}

class SegmentContainer extends Component {
  static propTypes = {
    company: PropTypes.object,
    trackPageViews: PropTypes.bool,
    viewer: PropTypes.object,
  };

  static defaultProps = {
    trackPageViews: false,
  };

  componentDidMount() {
    if (__DEV__) {
      return;
    }

    loadSegmentSDK();

    this.identifyUser();
    this.trackPageViews();
  }

  componentWillUnmount() {
    if (__DEV__) {
      return;
    }

    if (!this._unlisten) {
      return;
    }

    this._unlisten();
  }

  identifyUser = () => {
    const { getExperimentGroups, viewer } = this.props;
    const experimentGroups = getExperimentGroups();

    if (!viewer?._id) {
      window.analytics.identify({
        ...experimentGroups,
      });
      return;
    }

    window.analytics.identify(viewer._id, {
      ...experimentGroups,
      ...(viewer.avatarURL && {
        avatar: viewer.avatarURL,
      }),
      createdAt: new Date(viewer.created).toISOString(),
      email: viewer.email,
      name: viewer.name,
    });

    viewer.companies.forEach((company) => {
      window.analytics.group(company._id);
    });
  };

  trackPageViews = () => {
    if (!this.props.trackPageViews) {
      return;
    }

    this._unlisten = browserHistory.listen(this.onRouteChange);
    this.onRouteChange();
  };

  onRouteChange = () => {
    window.analytics.page();
  };

  onTrackEvent = (eventName, eventData) => {
    if (__DEV__) {
      return;
    }

    loadSegmentSDK();

    window.analytics.track(eventName, eventData);
  };

  render() {
    const childProps = Object.assign({}, this.props);
    delete childProps.company;
    delete childProps.getExperimentGroups;
    delete childProps.trackPageViews;
    delete childProps.viewer;
    return (
      <TrackSegmentEventContext.Provider value={this.onTrackEvent}>
        <Helmet
          link={[
            {
              href: 'https://sgmnt-cdn.canny.io',
              rel: 'preconnect',
            },
            {
              href: 'https://sgmnt-api.canny.io',
              rel: 'preconnect',
            },
          ]}
        />
        {cloneElementWithProps(this.props.children, {
          ...childProps,
        })}
      </TrackSegmentEventContext.Provider>
    );
  }
}

export default compose(
  withContexts({
    company: CompanyContext,
    getExperimentGroups: GetExperimentGroupsContext,
    viewer: ViewerContext,
  }),
)(SegmentContainer);
